import { render, staticRenderFns } from "./RuralCroppingFarm.vue?vue&type=template&id=bdb93a38&scoped=true&"
import script from "./RuralCroppingFarm.vue?vue&type=script&lang=ts&"
export * from "./RuralCroppingFarm.vue?vue&type=script&lang=ts&"
import style0 from "./RuralCroppingFarm.vue?vue&type=style&index=0&id=bdb93a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb93a38",
  null
  
)

export default component.exports